module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__content section"
  }, [_c('div', {
    staticClass: "section__wrapper"
  }, [_c('div', {
    staticClass: "section__content"
  }, [_c('h2', {}, [_vm._v("404 - Sorry, there's nothing here")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v("Go home")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c38fbc06","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 235
// module chunks = 1